import { forwardRef } from "@kirvanobr/system";

import { useModalFooter, UseModalFooterProps } from "./use-modal-footer";

export interface ModalFooterProps extends UseModalFooterProps {}

const ModalFooter = forwardRef<"footer", ModalFooterProps>((props, ref) => {
  const {
    Component,
    children,
    leftContent,
    getFooterProps,
    getFooterButtonsProps,
    getFooterLeftContentProps,
  } = useModalFooter(props);

  return (
    <Component {...getFooterProps()}>
      {leftContent && <div {...getFooterLeftContentProps()}>{leftContent}</div>}
      <div {...getFooterButtonsProps()}>{children}</div>
    </Component>
  );
});

ModalFooter.displayName = "UI.ModalFooter";

export default ModalFooter;
